import _defineProperty from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { vgField } from '../../channeldef';
import { getTimeUnitParts, normalizeTimeUnit } from '../../timeunit';
import { duplicate, entries, hash as _hash, isEmpty, replacePathInField, vals } from '../../util';
import { DataFlowNode } from './dataflow';
export var TimeUnitNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(TimeUnitNode, _DataFlowNode);

  var _super = _createSuper(TimeUnitNode);

  function TimeUnitNode(parent, formula) {
    var _this;

    _classCallCheck(this, TimeUnitNode);

    _this = _super.call(this, parent);
    _this.formula = formula;
    return _this;
  }

  _createClass(TimeUnitNode, [{
    key: "clone",
    value: function clone() {
      return new TimeUnitNode(null, duplicate(this.formula));
    }
  }, {
    key: "merge",
    value:
    /**
     * Merge together TimeUnitNodes assigning the children of `other` to `this`
     * and removing `other`.
     */
    function merge(other) {
      this.formula = Object.assign({}, this.formula); // if the same hash happen twice, merge

      for (var key in other.formula) {
        if (!this.formula[key]) {
          // copy if it's not a duplicate
          this.formula[key] = other.formula[key];
        }
      }

      var _iterator = _createForOfIteratorHelper(other.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          other.removeChild(child);
          child.parent = this;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      other.remove();
    }
    /**
     * Remove time units coming from the other node.
     */

  }, {
    key: "removeFormulas",
    value: function removeFormulas(fields) {
      var newFormula = {};

      var _iterator2 = _createForOfIteratorHelper(entries(this.formula)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              timeUnit = _step2$value[1];

          if (!fields.has(timeUnit.as)) {
            newFormula[key] = timeUnit;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.formula = newFormula;
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.as;
      }));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.field;
      }));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "TimeUnit ".concat(_hash(this.formula));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var transforms = [];

      var _iterator3 = _createForOfIteratorHelper(vals(this.formula)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var f = _step3.value;
          var field = f.field,
              as = f.as,
              timeUnit = f.timeUnit;

          var _a = normalizeTimeUnit(timeUnit),
              unit = _a.unit,
              utc = _a.utc,
              params = __rest(_a, ["unit", "utc"]);

          transforms.push(Object.assign(Object.assign(Object.assign(Object.assign({
            field: replacePathInField(field),
            type: 'timeunit'
          }, unit ? {
            units: getTimeUnitParts(unit)
          } : {}), utc ? {
            timezone: 'utc'
          } : {}), params), {
            as: [as, "".concat(as, "_end")]
          }));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return transforms;
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var formula = model.reduceFieldDef(function (timeUnitComponent, fieldDef) {
        var field = fieldDef.field,
            timeUnit = fieldDef.timeUnit;

        if (timeUnit) {
          var as = vgField(fieldDef, {
            forAs: true
          });
          timeUnitComponent[_hash({
            as: as,
            field: field,
            timeUnit: timeUnit
          })] = {
            as: as,
            field: field,
            timeUnit: timeUnit
          };
        }

        return timeUnitComponent;
      }, {});

      if (isEmpty(formula)) {
        return null;
      }

      return new TimeUnitNode(parent, formula);
    }
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t) {
      var _a = Object.assign({}, t),
          timeUnit = _a.timeUnit,
          other = __rest(_a, ["timeUnit"]);

      var normalizedTimeUnit = normalizeTimeUnit(timeUnit);
      var component = Object.assign(Object.assign({}, other), {
        timeUnit: normalizedTimeUnit
      });
      return new TimeUnitNode(parent, _defineProperty({}, _hash(component), component));
    }
  }]);

  return TimeUnitNode;
}(DataFlowNode);